import { BookingsFilter } from 'acscp/store';

export function getDomIdForFilter(filter: BookingsFilter): string {
    switch (filter) {
        case BookingsFilter.Enquiries:
            return 'EnquiriesBookingListId';
        case BookingsFilter.Quoted:
            return 'QuotedBookingListId';
        case BookingsFilter.Booked:
            return 'BookedBookingListId';
        case BookingsFilter.Flown:
            return 'FlownBookingListId';
        default:
        return '';
    }
}
